"use strict";
module.exports = {
    entityModel: 'shopConfig',
    events: {
        SHOP_CONFIG_UPDATED: 'SHOP_CONFIG_UPDATED',
        SHOP_CONFIG_CREATED: 'SHOP_CONFIG_CREATED',
    },
    actions: {
        get: 'v1.shopConfig.get',
        list: 'v1.shopConfig.list',
        resolveConfigForSubdomain: 'v1.shopConfig.resolveConfigForSubdomain',
        writeShopConfig: 'v1.shopConfig.writeShopConfig',
        writeNavbarConfig: 'v1.shopConfig.writeNavbarConfig',
        changeLandingPage: 'v1.shopConfig.changeLandingPage',
        upsert: 'v1.shopConfig.upsert',
        upsertWhenEmpty: 'v1.shopConfig.upsertWhenEmpty',
        updateWhenEmpty: 'v1.shopConfig.updateWhenEmpty',
        update: 'v1.shopConfig.update',
    },
    themes: {
        flaivyVarkalaTheme: 'flaivyVarkalaTheme',
        privabTheme: 'privabTheme',
    },
    files: {},
    pages: {
        types: {
            landingPage: 'landingPage',
            campaignPage: 'campaignPage',
            infoPage: 'infoPage',
            hiddenPage: 'hiddenPage',
        },
    },
};
